import React, { useRef, useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import CustomInput from "@/components/ui/customInput";
import { useContactUsMutation } from "@/redux/apiSlices/formApi";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { isValid } from "@/lib/utils";
import { validationRules } from "@/lib/validationRules";
import { useToast } from "@/components/ui/use-toast";
import { Controller, useForm } from "react-hook-form";
import { Textarea } from "../ui/textarea";
import emailjs from "emailjs-com"; // ✅ Import emailjs

export function EmailStoreModal({modelNumber, serialNo, storeAddress, storeEmail}) {
  const [open, setOpen] = useState(false);
  const { toast } = useToast();
  const formRef = useRef(null); // ✅ Create a ref for the form

  const {
    requiredAlphabetOnly,
    phoneNumber,
    email,
  } = validationRules;

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset, // ✅ Destructure reset from useForm
  } = useForm({ defaultValues: {} });

   const [contactUs, { data, isSuccess, isLoading: isUserLoading, isError, error: errMsg }] = useContactUsMutation();
    useEffect(() => {
      if (isSuccess) {
        if (data?.success) {
          toast({ title: "The email has been sent successfully." })
        }
      }
      if (isError) {
        toast({
          title: errMsg?.data?.msg,
        });
      }
    }, [isSuccess, isError]);

  const onSubmit = async (data) => {
    if (!formRef.current) return;

    try {
      const subject = `Online Open-Box Product Inquiry - ${modelNumber || "N/A"} / ${serialNo || "N/A"} / ${storeAddress || "N/A"}`;
      const formType=`Open-Box Contact Form`;
      const storeEmailAddress =`${storeEmail}`;
      const OpenBoxName =`${data.first_name} ${data.last_name}`;
      
      const openBoxItemName=`${modelNumber}`;
      const serialNumber=`${serialNo}`;
      const storeLocation=`${storeAddress}`;
      const description  = `<p>You have received a new request from <span style="color:#FF991F;" >${data.first_name} ${data.last_name}</span> to regarding <span style="color:#008DA6;">${modelNumber}</span> / <span style="color:#36B37E">${serialNo}</span> in <span style="color:#403294">${storeAddress}</span>. Please reach out to the customer for further assistance regarding this open-box item.</p>`
      const formData = { ...data, subject, storeEmailAddress, serialNumber, OpenBoxName, openBoxItemName, storeLocation, description, formType };

      await contactUs(formData);
      setOpen(false)
      reset(); // ✅ Reset form fields after successful submission
    } catch (error) {
      console.error("❌ Error sending email:", error);

      toast({
        title: "Failed to send email. Please try again later.",
      });
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
       {/* <Button className="px-[18px] h-[44px] hover:bg-inherit rounded-10 text-blue1 border-blue1 bg-white border">          */}
       <Button className="px-[18px] h-[44px] rounded-10 bg-blue1 border-blue1 text-white border">
          Contact Store
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-[610px] rounded-[20px] py-5 px-[66px] smd:px-[40px]">
        <DialogHeader>
          <DialogTitle className="text-[30px] font-medium text-blue1 leading-[44px] text-start pb-[10px]">
            Contact Store
          </DialogTitle>
          <DialogDescription className="m-0">
            <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
              <div>
                <div className="grid grid-cols-2 gap-x-5 mob:grid-cols-1">
                <input type="hidden" name="subject"
                //  value={`Online Open-Box Product Inquiry - ${modelNumber || "N/A"} - ${serialNo || "N/A"} / ${storeAddress || "N/A"}`} 
                />
                  <Controller
                    name="first_name"
                    control={control}
                    className={"mb-0"}
                    rules={requiredAlphabetOnly("First Name")}
                    render={({ field }) => (
                      <CustomInput
                        labelClassName="bg-white"
                        label="First Name*"                       
                        maxLength={25}
                        isInvalid={errors.first_name}
                        capitalizeFirst
                        errorMessage={errors.first_name?.message}
                        {...field}
                      />
                    )}
                  />

                  <Controller
                    name="last_name"
                    control={control}
                    rules={requiredAlphabetOnly("Last Name")}
                    render={({ field }) => (
                      <CustomInput
                        labelClassName="bg-white"
                        label="Last Name*"
                        maxLength={25}
                        isInvalid={errors.last_name}
                        capitalizeFirst
                        errorMessage={errors.last_name?.message}
                        {...field}
                      />
                    )}
                  />
                </div>

                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: "Please enter email ",
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                      message: "Please enter valid email",
                    },
                  }}
                  render={({ field }) => (
                    <CustomInput
                      label="Email"
                      maxLength={1000}
                      isInvalid={isValid("email", errors)}
                      errorMessage="Please enter valid email"
                      {...field}
                    />
                  )}
                />

           
                  <Controller
                  name="mobile"
                  control={control}
                  rules={{
                    required: "Phone number is required",
                    validate: (value) => value.trim() !== "" || "Only spaces are not allowed",
                    pattern: {
                      value: /^[0-9]+$/, // Only numbers
                      message: "Phone number must contain only digits",
                    },
                    minLength: {
                      value: 10, // Adjust based on your needs
                      message: "Please enter a valid 10-digit",
                    },
                    maxLength: {
                      value: 10, // Adjust based on your needs
                      message: "Please enter a valid 10-digit",
                    },
                  }}
                  render={({ field }) => (
                    <CustomInput
                      labelClassName="bg-white"
                      label="Phone Number*"
                      isInvalid={isValid("mobile", errors)}
                      errorMessage={errors.mobile?.message}
                      {...field}
                    />
                  )}
                />

                <div className="flex space-x-[10px]">
                  <Controller
                    name="message"
                    control={control}
                    rules={{ 
                      required: "Please enter your message", 
                      maxLength: { value: 1000, message: "Message cannot exceed 1000 characters" }
                    }}
                    render={({ field }) => (
                      <Textarea
                        name="message" // ✅ Ensure correct name for EmailJS
                        placeholder="Message Here"
                        maxLength={1000}
                        className="mt-[10px]"
                        isInvalid={isValid("message", errors)}
                        errorMessage={errors.message?.message}
                        {...field}
                      />
                    )}
                  />
                </div>

                <div className="flex space-x-4 justify-end mt-5">
                  <Button
                    type="submit"
                    className="w-full max-w-[142px] px-[18px] h-[44px] hover:bg-inherit rounded-10 text-blue1 border-blue1 hover:bg-blue1 hover:text-white bg-white border"
                  >
                    Send
                  </Button>
                </div>
              </div>
            </form>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-start"></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}